// frontend-react/src/App.js (ΠΛΗΡΕΣ ΚΑΙ ΕΝΗΜΕΡΩΜΕΝΟ)

import React, { useContext } from 'react';
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import { AuthContext, AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

// Import Components
import OnboardingTour from './components/OnboardingTour';
import Sidebar from './components/Sidebar';
import TerminalBar from './components/TerminalBar';
import LoadingSpinner from './components/LoadingSpinner';
import NotificationHandler from './components/NotificationHandler';

// Import Pages
import LoginPage from './pages/LoginPage';
import ForgotPassword from './pages/ForgotPassword';
import ForgotUsername from './pages/ForgotUsername'; // Προσθήκη Import
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail'; // Προσθήκη Import
import ControlDeck from './pages/ControlDeck';
import Performance from './pages/Performance';
import Analytics from './pages/Analytics';
import ResearchValidation from './pages/ResearchValidation';
import Settings from './pages/Settings';
import Logs from './pages/Logs';
import MarketIntelligence from './pages/MarketIntelligence';
import Today from './pages/Today';
import Plans from './pages/Plans';
import Billing from './pages/Billing';
import Methodology from './pages/Methodology';
import Account from './pages/Account';
import AdminPanel from './pages/AdminPanel';

import './App.css';
import './Workstation.css';

export function AppContent() {
  const { user, loading, isLocalExecution } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="fullscreen-loader">
        <LoadingSpinner />
      </div>
    );
  }

  const hasScannerAccess = isLocalExecution || Boolean(user?.scanner_access);
  const hasMethodologyAccess = isLocalExecution || Boolean(user?.methodology_access);

  return (
    <div className="app-layout">
      {user && <Sidebar />}
      
      <div className="content-wrapper"> 
        {user && hasScannerAccess && isLocalExecution && <TerminalBar />}
        
        {user && hasScannerAccess && !isLocalExecution && !user.has_completed_onboarding && <OnboardingTour />}
        
        <main className={!user ? "main-content-full" : "main-content"}>
          <Routes>
            {!user ? (
              <>
                {/* Routes για μη συνδεδεμένους χρήστες */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/login/callback" element={<LoginPage />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/forgot-username" element={<ForgotUsername />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="*" element={<Navigate to="/login" />} />
              </>
            ) : hasScannerAccess ? (
              <>
                {/* Πλήρης πρόσβαση για έγκυρους συνδρομητές */}
                <Route path="/" element={<Navigate to="/today" />} />
                <Route path="/today" element={<Today />} />
                <Route path="/trade-plans" element={<Plans />} />
                <Route path="/control-deck" element={isLocalExecution ? <ControlDeck /> : <Navigate to="/today" />} />
                <Route path="/performance" element={isLocalExecution ? <Performance /> : <Navigate to="/today" />} />
                <Route path="/analytics" element={isLocalExecution ? <Analytics /> : <Navigate to="/today" />} />
                <Route path="/research-validation" element={isLocalExecution ? <ResearchValidation /> : <Navigate to="/today" />} />
                <Route path="/market-intelligence" element={<MarketIntelligence />} />
                <Route path="/methodology" element={<Methodology />} />
                {!isLocalExecution && <Route path="/account" element={<Account />} />}
                <Route path="/workspace-settings" element={isLocalExecution ? <Settings /> : <Navigate to="/today" />} />
                <Route path="/logs" element={isLocalExecution ? <Logs /> : <Navigate to="/today" />} />
                {!isLocalExecution && <Route path="/billing" element={<Billing />} />}
                {!isLocalExecution && user.role === 'admin' && <Route path="/admin" element={<AdminPanel />} />}
                <Route path="*" element={<Navigate to="/today" />} />
              </>
            ) : hasMethodologyAccess ? (
              <>
                {/* Η εφάπαξ αγορά κρατά μόνιμη πρόσβαση στη Μεθοδολογία, ακόμη χωρίς ενεργό Scanner. */}
                <Route path="/" element={<Navigate to="/methodology" />} />
                <Route path="/methodology" element={<Methodology />} />
                <Route path="/account" element={<Account />} />
                <Route path="/billing" element={<Billing />} />
                <Route path="*" element={<Navigate to="/methodology" />} />
              </>
            ) : (
              <>
                <Route path="/account" element={<Account />} />
                <Route path="/billing" element={<Billing />} />
                <Route path="*" element={<Navigate to="/billing" />} />
              </>
            )}
          </Routes>
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <NotificationHandler />
          <AppContent />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
